import { DocumentNode, gql } from '@apollo/client';
import {
  BoxProps,
  Button,
  HStack,
  LinkBox,
  LinkOverlay,
  Spacer,
  Text,
  VStack,
} from '@chakra-ui/react';
import { convertFromRaw } from 'draft-js';
import NextLink from 'next/link';
import * as React from 'react';

import { usePostHref } from '@/hooks/usePostHref';
import { BarChartIcon } from '@/imports/ui/chakra/feather';

import { PollAnnouncement_PollFragment } from './graphql-types/PollAnnouncement_PollFragment';

import { Card } from '../Card';

const POST_FRAGMENT = gql`
  fragment PollAnnouncement_PollFragment on PollV2 {
    _id
    pollTitle: title
    pollBody: description
  }
`;

export const Poll: React.FC<
  { poll: PollAnnouncement_PollFragment } & BoxProps
> & {
  pollFragment: DocumentNode;
} = ({ poll, children, ...rest }) => {
  const postHref = usePostHref(poll._id);

  return (
    <LinkBox>
      <Card {...rest}>
        <VStack overflow="hidden" alignItems="start" spacing="0" h="100%">
          <HStack>
            <BarChartIcon color="gray.500" />
            <Text textStyle="detail" color="gray.500" fontWeight="600">
              <LinkOverlay as={NextLink} href={postHref}>
                POLL
              </LinkOverlay>
            </Text>
          </HStack>
          <Text noOfLines={1} textStyle="bodyStrong">
            {poll.pollTitle}
          </Text>
          <Text noOfLines={2} textStyle="detail">
            {poll.pollBody ? convertFromRaw(poll.pollBody).getPlainText() : ''}
          </Text>
          <Spacer />
          <NextLink href={postHref}>
            <Button width="full" size="sm">
              Answer Poll
            </Button>
          </NextLink>
        </VStack>
      </Card>
      {children}
    </LinkBox>
  );
};
Poll.pollFragment = POST_FRAGMENT;
